export default "__VITE_ASSET__401564cc__"